export default "/images/hamburger-icon.svg?4ff2113367960b7946cdf83f24331a30";